import { useFeatureFlagsQuery } from '@/generated/graphql';

export function useBansEnabled() {
  const { data, loading } = useFeatureFlagsQuery();
  return {
    bansEnabled: data?.featureFlags.bansEnabled ?? false,
    loading,
  };
}
